exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=search][data-v-5029211d]::-webkit-search-cancel-button,input[type=search][data-v-5029211d]::-webkit-search-decoration,input[type=search][data-v-5029211d]::-webkit-search-results-button,input[type=search][data-v-5029211d]::-webkit-search-results-decoration{-webkit-appearance:none}", ""]);

// exports
